import { formatDate } from '@angular/common';

export const dateFormat = 'd MMM, y';
export const dateTimeFormat = 'd MMM, y hh:mm';

export enum dateFormats {
    DMY = 'dd/MM/yyyy',
    MDY = 'MM/dd/yyyy'
}

export const getCurrentDate = () => {
    return formatDate(new Date(), dateFormat, 'en-US');
}

export const getUTCDate = (date?: any) => {
    date = date ? new Date(date) : new Date()
    return date.toISOString();
}
export const convertDateFormat = (isoDate?: any) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const day = date.getDate();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  return `${day} ${month}, ${year}`;
}
export const getWeekStartAndEndDates = () => {
    const today = new Date();
    today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first)
    const weekStart = first + 1;
    const weekEnd = weekStart + 6;
    const startDate = new Date(today.setDate(weekStart));
    const endDate = new Date(today.setDate(weekEnd));
    let firstday = new Date(startDate.setHours(0,0,0)).toString();
    let lastday = new Date(endDate.setHours(23,59,59)).toString();
    return { StartDate: firstday, EndDate: lastday};
}
export const getNextWeekStartAndEndDates = () => {
    const today = new Date();
    today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first);
    const startDate = new Date(today.setDate(today.getDate() + 8));
    const endDate = new Date(today.setDate(today.getDate() + 6));
    let firstday = new Date(startDate.setHours(0,0,0)).toString();
    let lastday = new Date(endDate.setHours(23,59,59)).toString();
    return { StartDate: firstday, EndDate: lastday};
}
export const getNextWeekTwoStartAndEndDates = () => {
    const today = new Date();
    today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first);
    const startDate = new Date(today.setDate(today.getDate() + 8));
    const endDate = new Date(today.setDate(today.getDate() + 13));
    let firstday = new Date(startDate.setHours(0,0,0)).toString();
    let lastday = new Date(endDate.setHours(23,59,59)).toString();
    return { StartDate: firstday, EndDate: lastday};
}
export const getMonthStartAndEndDates = () => {
    const today = new Date();
    today.setHours(0,0,0,0);
    const year = today.getFullYear(), month = today.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    let firstDate = new Date(firstDay.setHours(0,0,0)).toString();
    let lastDate = new Date(lastDay.setHours(23,59,59)).toString();
    return { StartDate: firstDate, EndDate: lastDate };
}


export const getWeekStartAndEndDatesOnly = () => {
    const today = new Date();
    // today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first)
    const weekStart = first + 1;
    const weekEnd = weekStart + 6;
    const startDate = new Date(today.setDate(weekStart));
    const endDate = new Date(today.setDate(weekEnd));
    let firstday = getFormattedDate(startDate);
    let lastday = getFormattedDate(endDate);
    return { StartDate: firstday, EndDate: lastday};
}
export const getNextWeekStartAndEndDatesOnly = () => {
    const today = new Date();
    // today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first);
    const startDate = new Date(today.setDate(today.getDate() + 8));
    const endDate = new Date(today.setDate(today.getDate() + 6));
    let firstday = getFormattedDate(startDate);
    let lastday = getFormattedDate(endDate);
    return { StartDate: firstday, EndDate: lastday};
}
export const getNextWeekTwoStartAndEndDatesOnly = () => {
    const today = new Date();
    // today.setHours(0,0,0,0);
    const first = today.getDate() - today.getDay();
    today.setDate(first);
    const startDate = new Date(today.setDate(today.getDate() + 8));
    const endDate = new Date(today.setDate(today.getDate() + 13));
    let firstday = getFormattedDate(startDate);
    let lastday = getFormattedDate(endDate);
    return { StartDate: firstday, EndDate: lastday};
}
export const getMonthStartAndEndDatesOnly = () => {
    const today = new Date();
    // today.setHours(0,0,0,0);
    const year = today.getFullYear(), month = today.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    let firstDate = getFormattedDate(firstDay);
    let lastDate = getFormattedDate(lastDay);
    return { StartDate: firstDate, EndDate: lastDate };
}

export const getFormattedDate = (d: any) => {
    try {
      if (d) {
        const isDateObject = typeof d === 'object';
        if (isDateObject) {
          const f = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`
          return f;
        } else {
          const dobj = new Date(d);
          const f = `${dobj.getMonth() + 1}-${dobj.getDate()}-${dobj.getFullYear()}`
          return f;
        }
      }
      return d;
    } catch (err) { }
  }


export const calculateMinMaxDates = (number: number) => {
    if ( number !== undefined && number !== null ) {
        const today = new Date();
        today.setHours(0,0,0,0);
        today.setDate(today.getDate() + number);
        return new Date(today);
    } else {
        return null;
    }
}
